// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__34MaP","namePhoneContainer":"style_namePhoneContainer__2DVQG"};